import { gql } from '@apollo/client'

// ─── Apply Sync ───────────────────────────────────────────────────────────────

export const APPLY_SYNC_TWILIO_TEMPLATES = gql`
  mutation ApplySyncTwilioTemplates($acceptedSids: [String]!) {
    applySyncTwilioTemplates(acceptedSids: $acceptedSids) {
      success
      message
      count
    }
  }
`

// ─── Create ───────────────────────────────────────────────────────────────────

export const CREATE_TWILIO_WHATSAPP_TEMPLATE = gql`
  mutation CreateTwilioWhatsappTemplate($input: CreateTwilioTemplateInput!) {
    createTwilioWhatsappTemplate(input: $input) {
      success
      message
      contentSid
    }
  }
`

// ─── Toggle Active ────────────────────────────────────────────────────────────

export const TOGGLE_TWILIO_TEMPLATE_ACTIVE = gql`
  mutation ToggleTwilioTemplateActive($contentSid: String!, $isActive: Boolean!) {
    toggleTwilioTemplateActive(contentSid: $contentSid, isActive: $isActive) {
      success
      message
      template {
        contentSid
        friendlyName
        isActive
      }
    }
  }
`

// ─── Archive ──────────────────────────────────────────────────────────────────

export const ARCHIVE_TWILIO_TEMPLATE = gql`
  mutation ArchiveTwilioTemplate($contentSid: String!) {
    archiveTwilioTemplate(contentSid: $contentSid) {
      success
      message
      template {
        contentSid
        friendlyName
        isActive
        isArchived
      }
    }
  }
`

// ─── Delete ───────────────────────────────────────────────────────────────────

export const DELETE_TWILIO_TEMPLATE = gql`
  mutation DeleteTwilioTemplate($contentSid: String!) {
    deleteTwilioTemplate(contentSid: $contentSid) {
      success
      message
    }
  }
`

// ─── Submit for Approval ──────────────────────────────────────────────────────

export const SUBMIT_TWILIO_TEMPLATE_FOR_APPROVAL = gql`
  mutation SubmitTwilioTemplateForApproval($contentSid: String!) {
    submitTwilioTemplateForApproval(contentSid: $contentSid) {
      success
      message
      approvalStatus
    }
  }
`

// ─── Update Config (variable_mapping, allowed_modules, llm_*) ─────────────────

export const UPDATE_TWILIO_TEMPLATE_CONFIG = gql`
  mutation UpdateTwilioTemplateConfig(
    $contentSid: String!
    $variableMapping: GenericScalar
    $allowedModules: [String]
    $llmDescription: String
    $llmTags: [String]
    $llmInvocable: Boolean
  ) {
    updateTwilioTemplateConfig(
      contentSid: $contentSid
      variableMapping: $variableMapping
      allowedModules: $allowedModules
      llmDescription: $llmDescription
      llmTags: $llmTags
      llmInvocable: $llmInvocable
    ) {
      success
      message
      template {
        contentSid
        friendlyName
        variableMapping
        allowedModules
        llmDescription
        llmTags
        llmInvocable
      }
    }
  }
`

// ─── Send ─────────────────────────────────────────────────────────────────────

export const SEND_TWILIO_WHATSAPP_TEMPLATE = gql`
  mutation SendTwilioWhatsappTemplate(
    $phone: String!
    $contentSid: String!
    $variables: GenericScalar
    $module: String
    $objectId: String
  ) {
    sendTwilioWhatsappTemplate(
      phone: $phone
      contentSid: $contentSid
      variables: $variables
      module: $module
      objectId: $objectId
    ) {
      success
      message
      providerId
    }
  }
`
